<template>
  <div class="tg-collapse" :class="classes" >
    <div class="tg-collapse__header" @click="handleClick" :style="showArrow ? '' : 'padding-left:10px;'">
      <slot name="header">
        <span>{{ title }}</span>
      </slot>
      <template v-if="showArrow">
        <i class="el-submenu__icon-arrow el-icon-arrow-down"></i>
      </template>
    </div>
    <div class="tg-collapse__container">
      <template v-if="showStatic">
        <div class="tg-collapse__static">
          <slot name="collapse-static-item"></slot>
        </div>
      </template>

      <div class="tg-collapse__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: {
    showStatic: Boolean,
    value: Boolean,
    title: String,
    showArrow: Boolean
  },
  computed: {
    classes() {
      return {
        active: this.active,
      };
    },
    active: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleClick() {
      if (this.showArrow) {
        this.$emit('on-arrow-click')
      }
    }
  }
};
</script>
